import { createAction } from 'redux-actions';
import { normalize } from 'normalizr';

import { events as eventsSchema } from '../schema/event';
import AlexaEventsService from '../services/AlexaEventsService'


const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST';
const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
const FETCH_EVENTS_FAILED = 'FETCH_EVENTS_FAILED';

const fetchEventsRequest = createAction(FETCH_EVENTS_REQUEST);
const fetchEventsSuccess = createAction(FETCH_EVENTS_SUCCESS);
const fetchEventsFailed = createAction(FETCH_EVENTS_FAILED);

export const getEvents = () => {
  return dispatch => {
    dispatch(fetchEventsRequest());

    AlexaEventsService.all()
      .then(events => dispatch(fetchEventsSuccess({
        ...normalize(events, eventsSchema)
      })))
      .catch(error => dispatch(
        fetchEventsFailed({
          notie: { type: 'error', message: 'Impossibile caricare gli eventi in questo momento.' },
        })
      ));
  };
};
